
import { watch } from 'vue';
import { reactive } from 'vue';
import { defineComponent } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export default defineComponent({
  name: 'pagination',
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    }
  },
  emits: {
    // 声明 size-change 事件，并指定其类型为一个数字
    'size-change': (pageSize: number) => true,
    // 声明 current-change 事件，并指定其类型为一个数字
    'current-change': (currentPage: number) => true,
    // 声明 change 事件，并指定其类型为一个数字
    'change': (params: { page: number, size: number }) => true,
  },
  setup(props, context) {
    const router = useRouter();
    const route = useRoute();
    const { size: qSize = props.pageSize, page: qPage = props.currentPage } = route.query;
    const query = reactive({
      page: Number(qPage),
      size: Number(qSize),
    })
    context.emit('change', { page: query.page, size: query.size });

    const handleSizeChange = (size: number) => {
      query.size = size;
      router.push({ path: route.path, query: { size: query.size, page: query.page } });
    };
    const handleCurrentChange = (page: number) => {
      query.page = page;
      router.push({ path: route.path, query: { size: query.size, page: query.page } });
    }

    watch(() => query, ({ page, size }) => {
      context.emit('change', { page, size });
    }, { deep: true });

    watch(() => { return { name: route.name, rq: route.query } }, (newVal, oldVal) => {
      if (oldVal.name === newVal.name) {
        // 同页面翻页变换
        (query.page = Number(newVal.rq.page || 1));
        (query.size = Number(newVal.rq.size || 10));
      }
    })

    return {
      handleSizeChange,
      handleCurrentChange,
    }
  },
});
